import * as React from "react"
import styled from "styled-components"
import { breakpoint, scale, colors } from "../../styles"
import { INNER_MAX_WIDTH } from "../../constants"

export interface MyPagesHeroProps {
	content: React.ReactNode
	media?: React.ReactNode
	children?: React.ReactNode
}

const MyPagesHeroStyled = styled.div`
	position: relative;
	background-color: ${colors.blue33};
`

const MediaContainer = styled.div`
	position: relative;

	&:after {
		content: "";
		display: block;
		padding-bottom: 72.5%;
	}

	${breakpoint("m")`
		&:after {
			padding-bottom: 28.88%;
		}
	`}
`

const Media = styled.figure`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;

	img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center;
	}
`

const Overlay = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: linear-gradient(
		180deg,
		rgba(0, 0, 0, 0) 5.33%,
		rgba(0, 0, 0, 0.4) 99.63%
	);
`

const ContentContainer = styled.div`
	position: absolute;
	top: 60%;
	left: 50%;
	transform: translateY(-50%) translateX(-50%);
	width: 100%;
	max-width: ${scale.px(INNER_MAX_WIDTH)};
	padding: 0 ${scale.px(3)};

	${breakpoint("m")`
		top: 50%;
	`}
`

const MyPagesHero: React.FC<MyPagesHeroProps> = (props) => {
	return (
		<MyPagesHeroStyled>
			<MediaContainer>
				{props.media && <Media>{props.media}</Media>}
			</MediaContainer>

			<Overlay>
				<ContentContainer>{props.content}</ContentContainer>
			</Overlay>
			{props.children}
		</MyPagesHeroStyled>
	)
}

export { MyPagesHero }
